var map = {
  "./AriaSymptoms/Document/": "64231",
  "./Background/Document/": "25284",
  "./Behaviour/Document/": "45958",
  "./Checklist/Document/": "45345",
  "./Clinicalstudy/Document/": "61755",
  "./ClpAndCnpTests/Document/": "16964",
  "./Cognition/Document/": "30918",
  "./Comorbidity/Document/": "3237",
  "./Dbs/Document/": "21540",
  "./Diagnosis/Document/": "61217",
  "./DiagnosticSurvey/Document/": "75570",
  "./DiagnosticTests/Document/": "84488",
  "./DietTherapy/Document/": "46198",
  "./DoctorsOrders/Document/": "24619",
  "./Examination/Document/": "22371",
  "./FunctionalPerformance/Document/": "54350",
  "./FunctionalPerformanceMgravis/Document/": "90646",
  "./GeneTest/Document/": "25193",
  "./Generalhealth/Document/": "16817",
  "./Imaging/Document/": "18359",
  "./InflammatoryDiseaseActivity/Document/": "99570",
  "./InterviewSurveys/Document/": "46847",
  "./Lifestyle/Document/": "90948",
  "./Medication/Document/": "31610",
  "./Motor/Document/": "29755",
  "./MotorFunctionAndMobilityAid/Document/": "95390",
  "./MotorFunctionHuntington/Document/": "93650",
  "./MyService/Document/": "50815",
  "./NeurologicalStatusAndEDSS/Document/": "22850",
  "./Notes/Document/": "25303",
  "./Nutrition/Document/": "40070",
  "./OtherSymptoms/Document/": "89357",
  "./PatientFiles/Document/": "35341",
  "./Procedure/Document/": "86965",
  "./Profile/Document/": "12068",
  "./Pulmonary/Document/": "29800",
  "./Relapse/Document/": "85963",
  "./Rtms/Document/": "16815",
  "./Seizure/Document/": "1105",
  "./SurgicalTreatment/Document/": "61634",
  "./Tdcs/Document/": "170",
  "./ThalamotomyHifu/Document/": "93201",
  "./Therapy/Document/": "9002",
  "./Treatment/Document/": "90384",
  "./Updrs/Document/": "8346",
  "./Vns/Document/": "9795",
  "./_Boilerplate/Document/": "83318"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 31889;
